import API from "./API";

export const getCityDataAPI = async (payload, hostname) => {
    try {
        const response = await API.get(`programmatic-pages/city-state-combinations`, { headers: payload });
        console.log("response for city", response?.data)
        return response;
    }
    catch (error) {
        if (error?.response?.data?.message === "No value present") {
            return error?.response?.data;
        }
        throw error;
    }
};